function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.259444 6.71439L5.55299 11.9383C5.89429 12.2761 6.44627 12.2717 6.78408 11.9296C7.1219 11.5874 7.11842 11.0363 6.77536 10.6985L2.99241 6.96515L13.1294 6.96515C13.6108 6.96515 14 6.57598 14 6.09452C14 5.61306 13.6108 5.22385 13.1294 5.22385L2.99241 5.22385L6.77536 1.49053C7.11838 1.15271 7.121 0.601596 6.78408 0.259438C6.61345 0.0870482 6.38881 -6.01033e-06 6.16418 -5.99069e-06C5.94302 -5.97136e-06 5.7219 0.0835674 5.55299 0.250757L0.259444 5.47465C0.0940155 5.63832 -5.53185e-07 5.86124 -5.32787e-07 6.09456C-5.12397e-07 6.3278 0.0931554 6.54982 0.259444 6.71439Z"
});

var SvgArrowLeft = function SvgArrowLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "#29394D",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-left.9ebdd036.svg";
export { ForwardRef as ReactComponent };